<template>
  <div class="auth-container" style="background-color: green;">
    <div v-if="!isAuthenticated">
      <button @click="login">Увійти</button>
    </div>
    <div v-else>
      <span>{{ connected ? '🟢' : '🔴' }} {{ connected ? 'SignalR підключено' : 'SignalR відключено' }}</span>
      <h2>Ви авторизовані</h2>
      <p>Ім'я користувача: {{ user?.profile?.name }}</p>
      <p>Email: {{ user?.profile?.email }}</p>
      <button @click="logout">Вийти</button>
    </div>
  </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import { userManager } from '../router'
import { watch } from 'vue'
import { geks } from '../composables/geks'
const { connected, startConnection, game } = geks()
const user = ref(null)
const isAuthenticated = ref(false)


onMounted(async () => {
  user.value = await userManager.getUser()
  isAuthenticated.value = !!user.value && !user.value?.expired
  if(user.value && !isAuthenticated.value) {
      user.value = await userManager.signinSilent()
      isAuthenticated.value = !!user.value && !user.value?.expired
  }
})

watch(isAuthenticated, async (newValue) => {
  if(newValue)
    await startConnection(user.value.access_token)
})

function login() { userManager.signinRedirect() }
function logout() { userManager.signoutRedirect() }
</script>